var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRightAlign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#BCCCD9",
    d: "M5.88889 6H18.1111C18.602 6 19 6.39797 19 6.88889V7.11111C19 7.60203 18.602 8 18.1111 8H5.88889C5.39797 8 5 7.60203 5 7.11111V6.88889C5 6.39797 5.39797 6 5.88889 6ZM10.8889 11H18.1111C18.602 11 19 11.398 19 11.8889V12.1111C19 12.602 18.602 13 18.1111 13H10.8889C10.398 13 10 12.602 10 12.1111V11.8889C10 11.398 10.398 11 10.8889 11ZM5.88889 16H18.1111C18.602 16 19 16.398 19 16.8889V17.1111C19 17.602 18.602 18 18.1111 18H5.88889C5.39797 18 5 17.602 5 17.1111V16.8889C5 16.398 5.39797 16 5.88889 16Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightAlign);
export default __webpack_public_path__ + "static/media/right-align.fd707c83a8689ecbb38f9c813c25e945.svg";
export { ForwardRef as ReactComponent };